import React, { Fragment } from 'react';
import { useRouter } from 'next/router';

import HelpDeskContent from '../HelpDeskContent';
import HelpDeskCategoryQuestion from './HelpDeskCategoryQuestion';
import FooterSimple from '../../FooterSimple';

import routes from '../../../utils/routes';
import { HELP_DESK_ICONS } from '../../../utils/assets';

type HelpDeskCategoryT = {
  categories: HelpDeskCategory[];
  category: HelpDeskCategory;
};

const HelpDeskCategory = ({ categories, category }: HelpDeskCategoryT) => {
  const router = useRouter();

  const breadcrumbPages = [
    {
      label: category.categoryDescription,
      url: '',
    },
  ];

  const onClickQuestionHandler = (question: string) =>
    router.push(`${routes.helpDesk}/${router.query.category}/${question}`);

  return (
    <Fragment>
      <HelpDeskContent
        categories={categories}
        breadcrumbPages={breadcrumbPages}
        icon={HELP_DESK_ICONS(category.icon)}
        title={category.categoryDescription}
        content={category.questions.map((question: HelpDeskQuestion, index: number) => (
          <HelpDeskCategoryQuestion
            key={`help_desk_question_${index}`}
            title={question.title}
            onClick={() => onClickQuestionHandler(question.keyword)}
          />
        ))}
      />

      <FooterSimple />
    </Fragment>
  );
};

export default HelpDeskCategory;
